const FARMUNIT_MUTABLE_FIELDS = [
  'unit_id',
  'irrigated_acres',
  'county',
  'mapped_acres',
  'location',
  'method',
  'accessor_code',
  'section',
  'township',
  'range',
  'vote',
  'leased',
  'transfer_authority',
  'producer_usage_percentage',
  'producer_cert_percentage',
  'custom_1',
  'custom_2',
  'custom_3',
  'custom_4',
  'custom_5',
  'custom_6',
  'custom_7',
  'custom_8',
  'custom_9',
  'custom_10',
  'custom_11',
  'producer',
  'owners',
  'secondary',
  'voter',
  'division',
  'flags',
  'waterYear',
  'offline_request_id'
]

const FARMUNIT_MUTABLE_FIELD_SET = new Set(FARMUNIT_MUTABLE_FIELDS)

export const sanitizeFarmunitPayload = (payload = {}) => {
  if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
    return payload
  }

  return Object.keys(payload).reduce((sanitized, key) => {
    if (FARMUNIT_MUTABLE_FIELD_SET.has(key)) {
      sanitized[key] = payload[key]
    }

    return sanitized
  }, {})
}

